import React, { useState, useEffect } from 'react';
import useSWR from 'swr';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import DataGrid, { Column, Editing } from 'devextreme-react/data-grid';
import { Popup as MyPopup, ToolbarItem as PopupToolbar } from 'devextreme-react/popup';
import { Form, GroupItem, ButtonItem, EmptyItem, Item, Label } from 'devextreme-react/form';
import Toolbar from 'devextreme-react/toolbar';
import ScrollView from 'devextreme-react/scroll-view';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../../Hooks/useFetch';
import ActionNotifications from '../../Components/ActionNotifications';
import LoadingSpinnerModal from '../../Components/LoadingSpinnerModal';
import { useScreenSize } from '../../Utils/media-query';
import ErrorMessage from '../../Components/ErrorMessage';
import './styles.css'

export default function ReportingParamsPage() {
    const navigate = useNavigate(),
        params = useParams(),
        location = useLocation(),
        fetch = useFetch(navigate),
        [notifyResponse, setResponse] = useState({}),
        [showSpinner, setSpinner] = useState(false),
        { isXSmall, isSmall } = useScreenSize(),
        { data, isLoading, mutate, error } = useSWR(`${apiBaseURL}/api/BaseLineData?workCenterId=${location.state.labData.id}`),
        { data: unitData } = useSWR(`${apiBaseURL}/api/LabUnits`),
        [measurablesForm, setMeasurablesForm] = useState([{ labUnitId: 0, value: 0 }]),
        [labUnits, setLabUnits] = useState(false),
        [baseline, setBaseline] = useState({}),
        [state, setState] = useState({
            expressionBuilder: {},
            expressionLabel: '',
            expression: '',
            measurablesOpt: [{ id: 0, name: '', unit: '' }],
            labUnit: '',
            criticalEquipment: '',
            productionEffKPIEquation: '',
            equipmentUtilizationEquation: '',
            qualityEquation: '',
            labourProductivityEquation: '',
            trainingLevelEquation: '',
            editExpression: false,
            editing: '',
        });
    console.log('testing report')

    console.log(data)

    const fetchSuccessful = (response) => {
        setResponse(response)
        return response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    }

    const expressionToLabel = (e) => {
        console.log(e)
        if (e === null) return "";
        let selectedMeasurables = []
        for (let i = 0; i < measurablesForm.length; i++) {
            selectedMeasurables.push({
                id: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).id : null,
                label: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).name : null,
                value: measurablesForm[i].value,
            })
        }

        const getReplacementValue = (matchedString) => {
            console.log(matchedString)
            return selectedMeasurables.find(x => x.id === parseInt(matchedString))?.label
        };

        const newString = e.replace(/\[(\d+)\]/g, (match, capturedString) => {
            return `[${getReplacementValue(capturedString)}]`;
        })

        return newString;
    }
    const labelToExpression = (e) => {
        if (e === null) return "";
        let selectedMeasurables = []
        for (let i = 0; i < measurablesForm.length; i++) {
            selectedMeasurables.push({
                id: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).id : null,
                label: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).name : null,
                value: measurablesForm[i].value,
            })
        }

        const getReplacementValue = (matchedString) => {
            return selectedMeasurables.find(x => x.label === matchedString).id.toString()
        };

        const newString = e.replace(/\[(.*?)\]/g, (match, capturedString) => {
            return `[${getReplacementValue(capturedString)}]`;
        })

        return newString;
    }

    useEffect(() => {
        if (data && unitData) {
            const measurables = data.data.workCenterMeasurables.map(x => ({ labUnitId: x.labUnit.id, value: x.value }));

            const newBaseline = {
                ...data.data,
                //labUnit: expressionToLabel(data?.data?.labUnit),
                measurables: measurables
            };
            setBaseline(newBaseline);

            const newMeasurablesOpt = unitData.data.map(x => ({ id: x.id, name: x.name, unit: x.unit, nameUnit: `${x.name} (${x.unit})`, isAtlasBoard: x.isAtlasBoard }));
            setState(prevState => ({
                ...prevState,
                measurablesOpt: newMeasurablesOpt
            }));

            if (measurables.length > 0) {
                setMeasurablesForm(measurables);
            }
        }
    }, [data, unitData])

    useEffect(() => {
        setBaseline(prevBaseline => ({ ...prevBaseline, measurables: measurablesForm }))
    }, [measurablesForm])

    //define function for adding a new measurable
    const addMeasurable = () => {
        setMeasurablesForm([...measurablesForm, {
            labUnitId: '',
            value: 0
        }]);
    };
    //define function for removing a new measurable
    const removeMeasurable = (index) => {
        const updatedMeasurables = [...measurablesForm];
        updatedMeasurables.splice(index, 1);
        setMeasurablesForm(updatedMeasurables);
    };


    //define the form item options
    const addMeasurableOptions = { icon: 'add', text: 'Add measurable', onClick: () => addMeasurable() }
    const measurableOptions = { items: state.measurablesOpt, searchEnabled: true, valueExpr: "id", displayExpr: "nameUnit" }

    const onShowPopup = () => {
        //expression builder popup
        if (state.editExpression) {
            let selectedMeasurables = []
            for (let i = 0; i < measurablesForm.length; i++) {
                selectedMeasurables.push({
                    id: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).id : null,
                    label: measurablesForm[i].labUnitId ? state.measurablesOpt.find(x => x.id === measurablesForm[i].labUnitId).name : null,
                    value: measurablesForm[i].value,
                })
            }

            const onFieldDataChanged = (e) => {
                if (e.dataField === 'expression') {
                    const newString = labelToExpression(e.value)

                    setState({ ...state, expression: newString, expressionLabel: e.value })
                } else if (e.dataField === 'operand') {
                    //get measurables name and id
                    const val = selectedMeasurables.find(x => x.id === e.value).id.toString()
                    const name = selectedMeasurables.find(x => x.id === e.value).label
                    //save value to expression and name to expressionLabel
                    setState({ ...state, expression: state.expression.concat(`[${val}]`), expressionLabel: state.expressionLabel.concat(`[${name}]`) })
                }
            }
            //console.log('expression', state.expression)
            //console.log('label', state.expressionLabel)

            const onSaveExpression = async (e) => {
                switch (state.editing) {
                    case 'labUnit':
                        setState({ ...state, labUnit: state.expression });
                        setBaseline({ ...baseline, labUnit: state.expressionLabel });
                        break;
                    case 'criticalEquipment':
                        setState({ ...state, criticalEquipment: state.expression });
                        setBaseline({ ...baseline, criticalEquipment: state.expressionLabel });
                        break;
                    case 'productionEff':
                        setState({ ...state, productionEffKPIEquation: state.expression });
                        setBaseline({ ...baseline, productionEffKPI: state.expressionLabel });
                        break;
                    case 'equipmentUtilization':
                        setState({ ...state, equipmentUtilizationEquation: state.expression });
                        setBaseline({ ...baseline, utilizationKPI: state.expressionLabel });
                        break;
                    case 'quality':
                        setState({ ...state, qualityEquation: state.expression });
                        setBaseline({ ...baseline, qualityKPI: state.expressionLabel });
                        break;
                    case 'labourProductivity':
                        setState({ ...state, labourProductivityEquation: state.expression });
                        setBaseline({ ...baseline, productivityKPI: state.expressionLabel });
                        break;
                    case 'averageTrainingLevel':
                        setState({ ...state, trainingLevelEquation: state.expression });
                        setBaseline({ ...baseline, trainingLevelKPI: state.expressionLabel });
                        break;
                    default:
                        break;
                }
            }

            return (
                <MyPopup
                    visible={state.editExpression}
                    width="75%"
                    height="auto"
                    fullScreen={isXSmall || isSmall ? true : false}
                    hideOnOutsideClick={true}
                    onHiding={() => setState({ ...state, editExpression: false, expression: '', expressionLabel: '' })}
                    title="Edit KPI Expression"
                >
                    <Form onFieldDataChanged={onFieldDataChanged}>
                        <Item dataField="operand" editorType="dxSelectBox" editorOptions={{ dataSource: selectedMeasurables, valueExpr: "id", displayExpr: "label" }} />
                        <Item dataField="expression" editorType="dxTextArea" editorOptions={{ value: state.expressionLabel }} />
                    </Form>
                    <PopupToolbar
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: "Save",
                            useSubmitBehavior: true,
                            onClick: (e) => { onSaveExpression(e) }
                        }}
                    />
                </MyPopup>
            )
        }
    }

    const renderGrid = () => {
        const expressionLUOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'labUnit' }) }
        const expressionCEOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'criticalEquipment' }) }
        const expressionPEOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'productionEff' }) }
        const expressionUOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'equipmentUtilization' }) }
        const expressionQOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'quality' }) }
        const expressionPOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'labourProductivity' }) }
        const expressionTOptions = { icon: 'edit', text: 'Edit Expression', onClick: () => setState({ ...state, editExpression: true, editing: 'averageTrainingLevel' }) }

        const onRowInserted = async (e) => {
            setSpinner(true);

            //function and option to capitalize the first letter of each word
            let arrName = e.data.name.split(" ")
            let arrUnit = e.data.unit.split(" ")
            for (let i = 0; i < arrName.length; i++) { arrName[i] = arrName[i].charAt(0).toUpperCase() + arrName[i].slice(1); }
            for (let i = 0; i < arrUnit.length; i++) { arrUnit[i] = arrUnit[i].charAt(0).toUpperCase() + arrUnit[i].slice(1); }
            const strName = arrName.join(" ")
            const strUnit = arrUnit.join(" ")

            const body = {
                name: strName,
                unit: strUnit,
                isAtlasBoard: true
            }
            let response = await fetch.post(`${apiBaseURL}/api/LabUnit`, body);
            console.log(response)
            if (fetchSuccessful(response)) { }

            setSpinner(false);
        }

        const onRowUpdated = async (e) => {
            setSpinner(true);
            const body = {
                id: e.data.id,
                name: e.data.name,
                unit: e.data.unit,
                isAtlasBoard: e.data.isAtlasBoard
            }
            let response = await fetch.put(`${apiBaseURL}/api/LabUnit`, body);
            console.log(body)

            if (fetchSuccessful(response)) { };
            setSpinner(false);
        }

        const onRowRemoved = async (e) => {
            setSpinner(true);
            console.log(e);
            let response = await fetch.delete(`${apiBaseURL}/api/LabUnit?id=${e.data.id}`);
            if (fetchSuccessful(response)) { };
            setSpinner(false);

        }

        //converts the measurable value into something the API can read (array of numbers with maxLength = measurables for that lab)
        const onFieldDataChanged = (e) => {
            if (e.dataField.includes('measurables')) {
                const regExp = /\[([^\]]+)]/g;
                const matches = regExp.exec(e.dataField);
                let temp = [...measurablesForm]
                if (e.dataField.includes('value')) {
                    temp[matches[1]].value = e.value
                } else {
                    temp[matches[1]].labUnitId = unitData.data.find(x => x.id === e.value).id
                }
                setMeasurablesForm(temp)
            }
        }

        //function for adding the reporting params
        const onSubmitParams = async (e) => {
            setSpinner(true);

            const body = {
                locationId: baseline.workCenter.id,
                workCenterMeasurables: measurablesForm,
                labHours: baseline.labHours,
                manHours: baseline.manHours,
                baselineMultiplier: baseline.baselineMultiplier,
                sumOfTrainingLevel: baseline.sumOfTrainingLevel,
                totalLabPersonal: baseline.totalLabPersonal,
                labUnit: state.labUnit === "" ? baseline.labUnit : state.labUnit,
                criticalEquipment: state.criticalEquipment === "" ? baseline.criticalEquipment : state.criticalEquipment,
                productionEffectivenessKPI: state.productionEffKPIEquation === "" ? baseline.productionEffKPI : state.productionEffKPIEquation,
                utilizationKPI: state.equipmentUtilizationEquation === "" ? baseline.utilizationKPI : state.equipmentUtilizationEquation,
                qualityKPI: state.qualityEquation === "" ? baseline.qualityKPI : state.qualityEquation,
                productivityKPI: state.labourProductivityEquation === "" ? baseline.productivityKPI : state.labourProductivityEquation,
                trainingLevelKPI: state.trainingLevelEquation === "" ? baseline.trainingLevelKPI : state.trainingLevelEquation
            }
            console.log(body)
            const response = await fetch.put(`${apiBaseURL}/api/BaselineData`, body);
            
            if (fetchSuccessful(response)) {
                mutate()
            };
            setSpinner(false);

        }

        return (
            <>
                <ScrollView height="100%" width="100%">
                    <Form formData={baseline} onFieldDataChanged={onFieldDataChanged}>
                        <GroupItem caption="Current Data" colCount={2}>
                            <Item dataField="labHours" editorType="dxNumberBox">
                                <Label text="Current Lab Hours" />
                            </Item>
                            <Item dataField="manHours" editorType="dxNumberBox">
                                <Label text="Current Man Hours" />
                            </Item>
                        </GroupItem>
                        <EmptyItem />
                        <GroupItem caption="Baseline Data" colCount={3}>
                            <Item dataField="baselineMultiplier" editorType="dxNumberBox" colCount={1} />
                            <Item dataField="sumOfTrainingLevel" editorType="dxNumberBox" colCount={1} />
                            <Item dataField="totalLabPersonal" editorType="dxNumberBox" colCount={1} />
                            <EmptyItem colSpan={3} />
                            <GroupItem caption="Measurables" colCount={2} colSpan={3}>
                                {baseline.measurables && baseline.measurables.length > 0 ?
                                    baseline.measurables.map((m, index) => (
                                        <Item key={`measurable${index}`} itemType="group" colCount={2}>
                                            <Item key={`type${index}`} colSpan={1} dataField={`measurables[${index}].labUnitId`} editorType="dxSelectBox" editorOptions={measurableOptions}>
                                                <Label text="Measurable" />
                                            </Item>

                                            <Item key={`value${index}`} colSpan={1} dataField={`measurables[${index}].value`} editorType="dxNumberBox"
                                                editorOptions={{
                                                    buttons: [{
                                                        name: 'trash',
                                                        location: 'after',
                                                        options: {
                                                            stylingMode: 'text',
                                                            icon: 'trash',
                                                            onClick: () => { removeMeasurable(index) },
                                                            visible: measurablesForm.length > 1 ? true : false
                                                        }
                                                    }]
                                                }}>
                                                <Label text="Measurable Value" />
                                            </Item>
                                        </Item>
                                    ))
                                    :
                                    measurablesForm && measurablesForm.map((m, index) => (
                                        <Item key={`measurable${index}`} itemType="group" colCount={2}>
                                            <Item key={`type${index}`} colSpan={1} dataField={`measurablesForm[${index}].labUnitId`} editorType="dxSelectBox" editorOptions={measurableOptions}>
                                                <Label text="Measurable" />
                                            </Item>

                                            <Item key={`value${index}`} colSpan={1} dataField={`measurablesForm[${index}].value`} editorType="dxNumberBox"
                                                editorOptions={{
                                                    buttons: [{
                                                        name: 'trash',
                                                        location: 'after',
                                                        options: {
                                                            stylingMode: 'text',
                                                            icon: 'trash',
                                                            onClick: () => { removeMeasurable(index) },
                                                            visible: measurablesForm.length > 1 ? true : false
                                                        }
                                                    }]
                                                }}>
                                                <Label text="Measurable Value" />
                                            </Item>
                                        </Item>
                                    ))
                                }
                                <ButtonItem horizontalAlignment={measurablesForm.length % 2 === 0 ? "right" : "left"} verticalAlignment="bottom" buttonOptions={addMeasurableOptions} colSpan={1} />
                            </GroupItem>
                            <GroupItem caption="KPI Calculations" colCount={4} colSpan={3}>
                                <Item dataField="labUnit" colSpan={3} />
                                <ButtonItem horizontalAlignment='left' verticalAlignment="bottom" buttonOptions={expressionLUOptions} colSpan={1} />
                                <Item dataField="criticalEquipment" colSpan={3} />
                                <ButtonItem horizontalAlignment='left' verticalAlignment="bottom" buttonOptions={expressionCEOptions} colSpan={1} />
                                <Item dataField="utilizationKPI" colSpan={3} />
                                <ButtonItem horizontalAlignment='left' verticalAlignment="bottom" buttonOptions={expressionUOptions} colSpan={1} />
                                <Item dataField="productivityKPI" colSpan={3} />
                                <ButtonItem horizontalAlignment='left' verticalAlignment="bottom" buttonOptions={expressionPOptions} colSpan={1} />
                                <Item dataField="trainingLevelKPI" colSpan={3} />
                                <ButtonItem horizontalAlignment='left' verticalAlignment="bottom" buttonOptions={expressionTOptions} colSpan={1} />
                            </GroupItem>
                        </GroupItem>
                        <ButtonItem horizontalAlignment="left" buttonOptions={{ text: 'Submit', type: 'default', onClick: () => onSubmitParams(baseline) }} colSpan={2} />
                    </Form>
                </ScrollView>
                <MyPopup
                    visible={labUnits}
                    onHiding={() => setLabUnits(false)}
                    hideOnOutsideClick={true}
                    title="Add Measurable"
                    width="75%"
                    height="50%"
                    resizeEnabled={true}
                >
                    <ScrollView>
                        <DataGrid
                            dataSource={state.measurablesOpt}
                            keyExpr="id"
                            columnAutoWidth={true}
                            onRowInserted={onRowInserted}
                            onRowUpdated={onRowUpdated}
                            onRowRemoved={onRowRemoved}
                        >
                            <Editing mode="row" allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} startEditAction='click' />
                            <Column dataField="name" />
                            <Column dataField="unit" />
                            <Column dataField="isAtlasBoard" visible={false} />
                        </DataGrid>
                    </ScrollView>
                </MyPopup>
            </>
        );
    }

    const renderTitle = () => <div style={{ color: "#FFD800", fontSize: "22px" }}><b>{params.name}</b></div>;
    const labUnitsOptions = { icon: "info", text: "Lab Units", onClick: () => setLabUnits(true) }

    if (isLoading) return <LoadingSpinnerModal show />;

    return (
        <div className="px-lg-4 content">
            {onShowPopup()}
            <ActionNotifications response={notifyResponse} />
            <LoadingSpinnerModal show={showSpinner} />
            <div className="px-2">
                <div className="boxCotainerWrapper whiteBG my-3">
                    {!error ?
                        <>
                            <Toolbar>
                                <Item location="before " locateInMenu="auto" render={renderTitle} />
                                <Item location="after" locateInMenu="auto" widget="dxButton" options={labUnitsOptions} />
                            </Toolbar>
                            {renderGrid()}
                        </>
                        :
                        <ErrorMessage />
                    }
                </div>
            </div>
        </div>
    );

}